import {Container, Singleton} from 'typescript-ioc'
import BaseApi from '@/api/BaseApi'
import {DmqttPublishAllForm} from "@/form/DeviceMqttForm";

@Singleton
export default abstract class DeviceMqttApi {

    abstract publishAll(form: DmqttPublishAllForm): Promise<void>
}

class DeviceMqttApiImpl extends BaseApi implements DeviceMqttApi {

    protected urlPrefix = 'device/mqtt'

    publishAll(form: DmqttPublishAllForm): Promise<void> {
        return this.axios.get('publishAll', {params: form})
    }
}

Container.bind(DeviceMqttApi).to(DeviceMqttApiImpl)
